import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg';
import { ReactComponent as Copy } from 'assets/icons/copy.svg';
import { copyTextToClipboard, getTextContent } from 'helpers';
import { useEffect, useRef, useState } from 'react';



const ApiConsole = ({ data }) => {
    const contentRef = useRef()

    const [productDropdown, setproductDropdown] = useState(false)
    const [operationDropdown, setOperationDropdown] = useState(false)
    const [activeLanguage, setActiveLanguage] = useState()
    const [copyButtonText, setCopyButtonText] = useState('Copy');
    const [height, setHeight] = useState('0px');
    const [ApiData, setApiData] = useState({
        selectedProduct: '',
        selectedOperation: '',
        selectedLanguage: '',
    })

    const toggleProductDropdown = (e) => {
        e.stopPropagation();
        setOperationDropdown(false);
        setHeight('0px');
        setproductDropdown(!productDropdown);
        setHeight(productDropdown ? '0px' : `255px`);
    };
    const handleProductChange = (product) => {
        setApiData((prevAPIData) => ({ ...prevAPIData, selectedProduct: product }));
        setproductDropdown(false);
        setHeight('0px');
        if (product.operations?.length > 0) {
            handleOperationChange(product.operations[0]);
        }
    };
    const toggleOperationDropdown = (e) => {
        e.stopPropagation();
        setproductDropdown(false);
        setHeight('0px');
        setOperationDropdown(!operationDropdown);
        setHeight(operationDropdown ? '0px' : `255px`);
    };
    const handleOperationChange = (operation) => {
        setApiData((prevAPIData) => ({ ...prevAPIData, selectedOperation: operation }));
        setproductDropdown(false);
        setHeight('0px');
        if (operation.languages?.length > 0) {
            handleLanguageChange(operation.languages[0], 0);
        }
    };
    const handleLanguageChange = (language, index) => {
        setApiData((prevAPIData) => ({ ...prevAPIData, selectedLanguage: language }));
        setActiveLanguage(index)

    };


    const handleCopy = () => {
        const contentToCopy = document.getElementById('contentToCopy');
        if (contentToCopy) {
            const textToCopy = contentToCopy.innerText;
            copyTextToClipboard(textToCopy);
            setCopyButtonText('Copied');
            setTimeout(() => {
                setCopyButtonText('Copy');
            }, 2000);
        }
    };



    useEffect(() => {
        if (data && data[0]?.products?.length > 0 && !ApiData.selectedProduct) {
            handleProductChange(data[0].products[0]);
        }
        if (ApiData.selectedProduct && ApiData.selectedProduct.operations?.length > 0 && !ApiData.selectedOperation) {
            handleOperationChange(ApiData.selectedProduct.operations[0]);
        }
        if (ApiData.selectedOperation && ApiData.selectedOperation.languages?.length > 0 && !activeLanguage) {
            handleLanguageChange(ApiData.selectedOperation.languages[0], 0);
        }
    }, [data, ApiData.selectedProduct, ApiData.selectedOperation, activeLanguage]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (contentRef.current && !contentRef.current.contains(e.target)) {
                setproductDropdown(false);
                setOperationDropdown(false);
                setHeight('0px');
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [contentRef]);

    if (!data) return

    return (
        <>
            <div className="apiintegration-console">
                <div className='apiintegration-console-header'>
                    <div className="apiintegration-console-header-item">
                        <label htmlFor="apiConsoleProduct">Choose product:</label>
                        <div id='apiConsoleProduct' className={`apiintegration-console-header-dropdown ${productDropdown ? 'open' : 'closed'}`} onClick={toggleProductDropdown}>
                            <div className={` apiintegration-console-header-select ${productDropdown ? 'open' : 'closed'}`}>
                                {ApiData.selectedProduct ? (
                                    <span>{ApiData.selectedProduct.name}</span>
                                ) : (
                                    'Select a product'
                                )}{' '}
                                <Arrow className="arrow" />
                            </div>
                            <div
                                ref={contentRef}
                                style={{ maxHeight: `${height}` }}
                                className={` apiintegration-console-header-options ${productDropdown ? 'open' : 'closed'}`}
                            >
                                {data[0]?.products?.map((product, index) => (
                                    <div
                                        key={index}
                                        className="apiintegration-console-header-options-item"
                                        onClick={() => handleProductChange(product)}
                                    >
                                        <span>{product.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="apiintegration-console-header-item">
                        <label htmlFor="apiConsoleOperation">Choose operation:</label>
                        <div id='apiConsoleOperation' className={`apiintegration-console-header-dropdown ${operationDropdown ? 'open' : 'closed'}`} onClick={toggleOperationDropdown}>
                            <div className={` apiintegration-console-header-select  ${operationDropdown ? 'open' : 'closed'}`}>
                                {ApiData.selectedOperation ? (
                                    <span>{ApiData.selectedOperation.name}</span>
                                ) : (
                                    'Select a operation'
                                )}{' '}
                                <Arrow className="arrow" />
                            </div>
                            <div
                                ref={contentRef}
                                style={{ maxHeight: `${height}` }}
                                className={`apiintegration-console-header-options  ${operationDropdown ? 'open' : 'closed'}`}
                            >
                                {ApiData.selectedProduct.operations?.map((operation, index) => (
                                    <div
                                        key={index}
                                        className="apiintegration-console-header-options-item"
                                        onClick={() => handleOperationChange(operation)}
                                    >
                                        <span>{operation.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="apiintegration-console-body">
                    <div id="contentToCopy">
                        {
                            ApiData.selectedLanguage.code ?
                                getTextContent(ApiData.selectedLanguage.code)
                                :
                                (<code>Soon</code>)

                        }
                    </div>
                    <button onClick={handleCopy} className='apiintegration-console-body-copy-btn'>
                        <Copy />{copyButtonText}
                    </button>
                </div>
                <div className='apiintegration-console-footer'>
                    {ApiData.selectedOperation.languages?.map((language, index) => (
                        <div
                            key={index}
                            className={`apiintegration-console-footer__tag ${activeLanguage === index ? "active" : ""}`}
                            onClick={() => handleLanguageChange(language, index)}
                        >
                            <span>{language.name}</span>
                        </div>
                    ))}
                </div>
            </div >
        </>
    );
}

export default ApiConsole;